import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { makeStyles } from '@mui/styles';
import { Button, Grid, Menu, MenuItem } from '@mui/material';

import instance from 'connection/instance';
import { downloadFile, turnOffEvent } from 'utils/helpers';
import { AnimatedLoaderIcon } from 'assets/icons';

const useStyles = makeStyles(() => ({
  link: {
    textDecoration: 'none',
    color: '#3d3f43',
  },
  loader: {
    width: 32,
    height: 32,
  },
}));
const DocumentOptions = (props) => {
  // prettier-ignore
  const { orderItem, orderItem: { reservation = {} }, ...other } = props;
  const classes = useStyles();

  const { t } = useTranslation();
  const [anchorEl, setAnchorEl] = useState(null);
  const [disabled, setDisabled] = useState(false);

  // prettier-ignore
  const documents = [
    (['confirmed', 'pending_for_refund', 'in_refund', 'refunded'].includes(reservation['state']) && {
      label: t('Orders.Ticket'),
      url: orderItem['ticket_receipt']?.['file_url'],
      isReceiptsActualize: true,
    }),
    !!orderItem['information_invoice_receipt'] && {
      label: t('Orders.InfoBill'),
      url: orderItem['information_invoice_receipt']?.['file_url'],
      method: 'get',
    },
  ].filter(i => !!i);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleLoadFile = (option) => (e) => {
    setDisabled(true);
    turnOffEvent(e);
    if (option.isReceiptsActualize) {
      instance
        .put(
          '/api/v1/rgd/attachments_receipts_actualize',
          { data: { order_item: { id: orderItem.id } } },
          { responseType: 'blob' },
        )
        .then((response) => downloadFile(response, option.label))
        .then(() => setAnchorEl(null))
        .then(() => setDisabled(false))
        .catch((error) => console.error(error));
    } else {
      instance
        .get(option.url, { responseType: 'blob' })
        .then((response) => downloadFile(response, option.label))
        .then(() => setAnchorEl(null))
        .then(() => setDisabled(false))
        .catch((error) => console.error(error));
    }
  };

  return (
    <Grid item>
      <Button
        {...other}
        size="small"
        color="primary"
        variant="contained"
        onClick={handleClick}
        endIcon={<MoreHorizIcon />}
        children={t('Actions.DownloadDocs')}
      />
      <Menu keepMounted anchorEl={anchorEl} onClose={() => setAnchorEl(null)} open={Boolean(anchorEl)}>
        {documents.map((option, key) => (
          <MenuItem {...{ key }} onClick={handleLoadFile(option)} disabled={disabled}>
            {disabled ? <AnimatedLoaderIcon className={classes.loader} /> : option.label}
          </MenuItem>
        ))}
        <MenuItem
          children={
            <a
              className={classes.link}
              onClick={() => setAnchorEl(null)}
              href={'/static/Памятка_пассажиру.pdf'}
              download
            >
              Памятка пассажиру
            </a>
          }
        />
      </Menu>
    </Grid>
  );
};

DocumentOptions.propTypes = {
  passenger: PropTypes.object,
  orderItem: PropTypes.object,
};

DocumentOptions.defaultProps = {
  passenger: {},
};

export default DocumentOptions;
